export const IS_LOGGING_OUT_KEY = 'isLoggingOut';
export const LOGGING_OUT_VALUE = 'true';

export const SESSION_EXPIRED_MESSAGE = 'For security, you have been logged out automatically due to inactivity.';
export const SESSION_EXPIRED_MESSAGE_TIMEOUT = 500; // milliseconds

// A refresh that fails for some reason is retried once before the session is given up on.
export const SESSION_VERIFICATION_RETRY_DELAY_MS = 1000;
